import React from 'react';
import propTypes from 'prop-types';
import { Emphasis, Title } from 'styles';
import { StyledSearchHeader } from 'styles/search';

const SearchHeader = ({ mainHeading, locationNames = [] }) => {
  const locationsWording =
    locationNames.length < 3 ? locationNames.join(', ') : ' multiple areas';

  return (
    <StyledSearchHeader>
      <Title>
        {mainHeading}{' '}
        {locationsWording && (
          <>
            in <Emphasis>{locationsWording}</Emphasis>
          </>
        )}
      </Title>
    </StyledSearchHeader>
  );
};

SearchHeader.propTypes = {
  mainHeading: propTypes.string,
  locationNames: propTypes.array
};

export default React.memo(SearchHeader);
